import { idb } from "../db/index.ts";
import { g } from "../util/index.ts";

export const sortChampionshipPlayers = <T extends { pid: number; stats: { gs: number; gp: number; min: number } }>(players: T[], numStarters: number) => {
	const sorted = [...players].sort((a, b) => b.stats.gs - a.stats.gs || b.stats.gp * b.stats.min - a.stats.gp * a.stats.min || a.pid - b.pid);
	return {
		starters: sorted.slice(0, numStarters),
		bench: sorted.slice(numStarters).sort((a, b) => b.stats.gp * b.stats.min - a.stats.gp * a.stats.min || a.pid - b.pid),
	};
};

export const getChampionshipRoster = async (tid: number, season: number) => {
	const players = await idb.getCopies.players({ statsTid: tid }, "noCopyCache");
	// Never use today's roster to reconstruct a historical championship.
	const participants = players.filter((p) => p.stats.some((s) => s.season === season && s.tid === tid && s.gp > 0));
	const rows = await idb.getCopies.playersPlus(participants, {
		attrs: ["pid", "name"],
		ratings: ["pos"],
		stats: ["gp", "gs", "min", "pts", "trb", "ast", "stl", "blk", "fgp", "tpp", "ftp"],
		season,
		tid,
		seasonType: "regularSeason",
		mergeStats: "totOnly",
		fuzz: true,
	});
	return sortChampionshipPlayers(rows, g.get("numPlayersOnCourt", season));
};
